import { css } from 'emotion'

export const textSmallestStyles = css`
  font-size: 0.8em;
`
